﻿import $ from "jquery"; // Keep for $vizzit only

import { css, hide, slideDown } from "./utils-jquery.js";

window.addEventListener("load", function () {
  if (getCookie("cookie_consent") !== "true") {
    if (sessionStorage.getItem("cookie_consent_closed") === null) {
      const menuHeight = document.querySelector(".main-header__content-wrapper")?.offsetHeight || 0;
      const cookieConsent = document.querySelector(".c-cookie-consent");
      const consentHeight = cookieConsent?.offsetHeight || 0;

      if (cookieConsent) {
        slideDown(cookieConsent, 200);
      }

      // Set the vertical position of the top-menu. This is an ugly workaround due to poor html.
      const menuSearch = document.querySelector(".main-header .menu-search-and-shorcuts");
      if (menuSearch) {
        css(menuSearch, "top", `${menuHeight + consentHeight}px`);
      }
    }
  } else {
    loadScripts();
  }
});

document.addEventListener("DOMContentLoaded", function () {
  // Cookie consent approved
  document.addEventListener("click", function (e) {
    if (e.target.closest(".cookie-consent-approved")) {
      const d = new Date();
      d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = "cookie_consent=true;" + expires + ";path=/";
      loadScripts();

      // Set the vertical position of the top-menu. This is an ugly workaround due to poor html.
      const menuHeight = document.querySelector(".main-header__content-wrapper")?.offsetHeight || 0;
      const menuSearch = document.querySelector(".main-header .menu-search-and-shorcuts");
      if (menuSearch) {
        css(menuSearch, "top", `${menuHeight}px`);
      }

      const cookieConsent = document.querySelector(".c-cookie-consent");
      if (cookieConsent) {
        hide(cookieConsent);
      }
    }
  });

  // Close button
  document.addEventListener("click", function (e) {
    if (e.target.closest(".c-cookie-consent .close-button")) {
      sessionStorage.setItem("cookie_consent_closed", "true");

      // Set the vertical position of the top-menu. This is an ugly workaround due to poor html.
      const menuHeight = document.querySelector(".main-header__content-wrapper")?.offsetHeight || 0;
      const menuSearch = document.querySelector(".main-header .menu-search-and-shorcuts");
      if (menuSearch) {
        css(menuSearch, "top", `${menuHeight}px`);
      }

      const cookieConsent = document.querySelector(".c-cookie-consent");
      if (cookieConsent) {
        hide(cookieConsent);
      }
    }
  });
});

const loadScripts = function () {
  // Siteimprove script
  const siteimproveScript = document.createElement("script");
  siteimproveScript.type = "application/javascript";
  siteimproveScript.async = true;
  siteimproveScript.src = "//siteimproveanalytics.com/js/siteanalyze_7894.js";
  document.body.appendChild(siteimproveScript);

  // Keep jQuery for $vizzit only
  $vizzit.cookie.set();
};

const getCookie = function (cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};
